module.exports = __webpack_public_path__ + "static/Downtown-Cville1.a9299aee.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/Downtown-Cville1.jpg
// module id = ./assets/Downtown-Cville1.jpg
// module chunks = 168707334958949